var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import 'focus-visible';
import { MuiThemeProvider, StylesProvider } from '@material-ui/core/styles';
import React from 'react';
import { ThemeProvider as StyledThemeProvider } from '../styled-components';
import createTheme from './createTheme';
/**
 * sub theme provider,
 * that will use when you want use multiple theme in one app
 */
export var RcSubThemeProvider = function (_a) {
    var themeProp = _a.theme, children = _a.children;
    var theme = createTheme(themeProp);
    return (React.createElement(MuiThemeProvider, { theme: theme },
        React.createElement(StyledThemeProvider, { theme: theme },
            React.createElement(React.Fragment, null, children))));
};
/**
 * theme wrapper, apply in root,
 * each app should always have one `RcThemeProvider` at root,
 * if you need multiple, use `RcSubThemeProvider` inside that `RcThemeProvider` */
export var RcThemeProvider = function (props) {
    return (React.createElement(StylesProvider, { injectFirst: true },
        React.createElement(RcSubThemeProvider, __assign({}, props))));
};
